import {
  LOADED,
  ADD_BOOK,
  REMOVE_BOOK,
  EDIT_BOOK,
  UPDATE_BOOK,
} from "./actionTypes";

const initialState = {
  books: [],
  bookToEdit: null,
};

const nextBookId = (books) => {
  return books.reduce((maxId, book) => Math.max(maxId, book.id), 0) + 1;
};

const bookReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADED:
      return { ...state, books: action.payload };

    case ADD_BOOK:
      const newBook = {
        id: nextBookId(state.books),
        name: action.payload.name,
        author: action.payload.author,
        thumbnail: action.payload.thumbnail,
        price: action.payload.price,
        rating: action.payload.rating,
        featured: action.payload.featured,
      };
      return {
        ...state,
        books: [...state.books, newBook],
      };

    case EDIT_BOOK:
      return {
        ...state,
        bookToEdit: action.payload,
      };

    case UPDATE_BOOK:
      const updatedBooks = state.books.map((book) => {
        if (book.id === action.payload.id) {
          return action.payload;
        }
        return book;
      });
      return {
        ...state,
        books: updatedBooks,
        bookToEdit: null,
      };

    case REMOVE_BOOK:
      return {
        ...state,
        books: state.books.filter((book) => book.id !== action.payload),
      };

    default:
      return state;
  }
};

export default bookReducer;
